var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5V4.2C16 3.0799 16 2.51984 15.782 2.09202C15.5903 1.71569 15.2843 1.40973 14.908 1.21799C14.4802 1 13.9201 1 12.8 1H11.2C10.0799 1 9.51984 1 9.09202 1.21799C8.71569 1.40973 8.40973 1.71569 8.21799 2.09202C8 2.51984 8 3.0799 8 4.2V5M10 10.5V15.5M14 10.5V15.5M3 5H21M19 5V16.2C19 17.8802 19 18.7202 18.673 19.362C18.3854 19.9265 17.9265 20.3854 17.362 20.673C16.7202 21 15.8802 21 14.2 21H9.8C8.11984 21 7.27976 21 6.63803 20.673C6.07354 20.3854 5.6146 19.9265 5.32698 19.362C5 18.7202 5 17.8802 5 16.2V5",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash01);
export default __webpack_public_path__ + "static/media/trash-01.7d51a56d4fc21c4984945073bdaa561f.svg";
export { ForwardRef as ReactComponent };